module.exports = __webpack_public_path__ + "img/cor.11483490.png";